/* eslint-disable no-param-reassign */
const valuesMap = new Map()

export function proxify(instance: MemoryStorage) {
  return new Proxy(instance, {
    set(_obj, prop: string | number, value) {
      if (Object.prototype.hasOwnProperty.call(MemoryStorage, prop)) {
        instance[prop] = value
      } else {
        instance.setItem(prop, value)
      }
      return true
    },
    get(_target, name: string | number) {
      if (Object.prototype.hasOwnProperty.call(MemoryStorage, name)) {
        return instance[name]
      }
      if (valuesMap.has(name)) {
        return instance.getItem(name)
      }
      return null
    },
  })
}

export class MemoryStorage {
  [key: string]: any
  [index: number]: string

  getItem(key: any) {
    const stringKey = String(key)
    if (valuesMap.has(key)) {
      return String(valuesMap.get(stringKey))
    }

    return null
  }

  setItem(key: any, val: any) {
    valuesMap.set(String(key), String(val))
  }

  removeItem(key: any) {
    valuesMap.delete(key)
  }

  clear() {
    valuesMap.clear()
  }

  key(i: any) {
    if (arguments.length === 0) {
      throw new TypeError('Failed to execute "key" on "Storage": 1 argument required, but only 0 present.')
    }

    const arr = Array.from(valuesMap.keys())
    return arr[i]
  }

  get length() {
    return valuesMap.size
  }
}
